import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Pembelian from "./pages/Pembelian";
import Stok from "./pages/Stok";
import Penjualan from "./pages/Penjualan";
import Jurnal from "./pages/Jurnal";
import Hutang from "./pages/Hutang";
import Laporan from "./pages/Laporan";
import Pengaturan from "./pages/Pengaturan";

export const HOME_BY_ROLE = { administrator: "/", admin: "/pembelian", kasir: "/penjualan", audit: "/laporan" };

const ROLES_ALL = ["administrator"];
const ROLES_BELI = ["administrator", "admin"];
const ROLES_JUAL = ["administrator", "kasir"];
const ROLES_LAPORAN = ["administrator", "audit"];

function Protected({ children, roles }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground" data-testid="auth-loading">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={HOME_BY_ROLE[user.role] || "/login"} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Protected roles={ROLES_ALL}><Dashboard /></Protected>} />
            <Route path="/pembelian" element={<Protected roles={ROLES_BELI}><Pembelian /></Protected>} />
            <Route path="/stok" element={<Protected roles={ROLES_BELI}><Stok /></Protected>} />
            <Route path="/penjualan" element={<Protected roles={ROLES_JUAL}><Penjualan /></Protected>} />
            <Route path="/jurnal" element={<Protected roles={ROLES_JUAL}><Jurnal /></Protected>} />
            <Route path="/hutang" element={<Protected roles={ROLES_ALL}><Hutang /></Protected>} />
            <Route path="/laporan" element={<Protected roles={ROLES_LAPORAN}><Laporan /></Protected>} />
            <Route path="/pengaturan" element={<Protected roles={ROLES_ALL}><Pengaturan /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
